/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceScheduleEntryDto } from '../../models/device-schedule-entry-dto';

export interface DeviceControllerGetSchedules$Params {
  deviceId: string;
  clientWorkspaceId: string;
}

export function deviceControllerGetSchedules(http: HttpClient, rootUrl: string, params: DeviceControllerGetSchedules$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceScheduleEntryDto>>> {
  const rb = new RequestBuilder(rootUrl, deviceControllerGetSchedules.PATH, 'get');
  if (params) {
    rb.path('deviceId', params.deviceId, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DeviceScheduleEntryDto>>;
    })
  );
}

deviceControllerGetSchedules.PATH = '/api/device/{clientWorkspaceId}/{deviceId}/schedules';
